import React from 'react';
import { useInView } from './useParallax';
import { SouthIndiaMap } from './JourneySVGs';
import './ArrivalSection.css';

const ROUTES = [
  {
    icon: '✈',
    head: 'By Air',
    body: <>Nearest airports are <strong>Chennai</strong> (~200 km, ~4 hrs) and <strong>Bengaluru</strong> (~200 km, ~4 hrs). Both have regular domestic and international connections.</>,
  },
  {
    icon: '🚂',
    head: 'By Train',
    body: <>Direct trains from <strong>Chennai Egmore</strong> via Villupuram to Tiruvannamalai station. Journey ~4–5 hours.</>,
  },
  {
    icon: '🚗',
    head: 'By Road',
    body: <>~200 km from Chennai (NH 79) or Bengaluru (NH 77). A comfortable 4–5 hour drive through Tamil Nadu.</>,
  },
];

export default function ArrivalSection() {
  const [mapRef, mapInView]     = useInView(0.08);
  const [textRef, textInView]   = useInView(0.08);

  return (
    <section className="arrival" id="arrival">
      <div className="arrival__inner">

        <div
          ref={mapRef}
          className={`arrival__map-col ${mapInView ? 'arrival__map-col--in' : ''}`}
        >
          <SouthIndiaMap className="arrival__map-svg" />
        </div>

        <div
          ref={textRef}
          className={`arrival__text-col ${textInView ? 'arrival__text-col--in' : ''}`}
        >
          <p className="arrival__eyebrow cinzel">Getting Here</p>
          <h2 className="arrival__title cinzel">
            Arriving at<br />
            <span className="arrival__accent">Tiruvannamalai</span>
          </h2>

          <div className="arrival__routes">
            {ROUTES.map(r => (
              <div key={r.head} className="arrival__route">
                <span className="arrival__route-icon">{r.icon}</span>
                <div>
                  <p className="arrival__route-head cinzel">{r.head}</p>
                  <p className="arrival__route-body">{r.body}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="arrival__footer">
            <p className="arrival__footer-text cinzel">
              From Tiruvannamalai town — 18 km north on the Vellore Highway to Vedanagari Ashram
            </p>
            <a href="tel:+919611701326" className="arrival__call cinzel">
              ☎ &nbsp;+91 96117 01326
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
